var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgF = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 14",
  viewBox: "0 0 200 200"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "F_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v200H0z",
  "data-name": "Rectangle 21"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13",
  style: {
    clipPath: "url(#F_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M190 200H10a10 10 0 0 1-10-10V10A10 10 0 0 1 10 0h180a10 10 0 0 1 10 10v180a10 10 0 0 1-10 10",
  "data-name": "Path 7"
}))));
export default SvgF;